export default __webpack_public_path__ + "static/media/milho-gray.d90d9917.svg";